/* eslint-disable eag/no-index */
import {z} from 'zod';

export const MagicPublishingMissingFieldSchema = z.enum([
  'MAKE',
  'MODEL',
  'MILEAGE',
  'POWER',
  'BODY',
  'REAL_PRODUCTION_YEAR',
  'TRANSMISSION',
  'FUEL',
  'DRIVE',
  'SELLING_PRICE',
]);
export type MagicPublishingMissingField = z.infer<typeof MagicPublishingMissingFieldSchema>;

export const ValidateMagicPublishingRequestBodySchema = z.object({
  vehicleId: z.string(),
});
export type ValidateMagicPublishingRequestBody = z.infer<
  typeof ValidateMagicPublishingRequestBodySchema
>;

export const ValidateMagicPublishingResponseBodySchema = z.object({
  isOk: z.boolean(),
  missingFields: z.array(MagicPublishingMissingFieldSchema),
  missingMandatoryFields: z.array(z.string()),
  hasSalesPhotos: z.boolean(),
});
export type ValidateMagicPublishingResponseBody = z.infer<
  typeof ValidateMagicPublishingResponseBodySchema
>;

export type ValidateMagicPublishingApiArg = ValidateMagicPublishingRequestBody;
export type ValidateMagicPublishingApiRes = ValidateMagicPublishingResponseBody;

export const CreateMagicPublishingRequestBodySchema = z.object({
  vehicleId: z.string(),
  replaceBackground: z.boolean().optional(),
  publishMobileDeViaAdvertisingBridge: z.boolean().optional(),
  publishVgpViaAdvertisingBridge: z.boolean().optional(),
  publishOtomotoViaAdvertisingBridge: z.boolean().optional(),
  publishAutocarisViaAdvertisingBridge: z.boolean().optional(),
  publishMercedesNaSkladeViaAdvertisingBridge: z.boolean().optional(),
  publishHyundaiPromiseViaAdvertisingBridge: z.boolean().optional(),
  publishAutoplacPlViaAdvertisingBridge: z.boolean().optional(),
});
export type CreateMagicPublishingRequestBody = z.infer<
  typeof CreateMagicPublishingRequestBodySchema
>;

export const CreateMagicPublishingResponseBodySchema = z.object({
  id: z.string(),
});
export type CreateMagicPublishingResponseBody = z.infer<
  typeof CreateMagicPublishingResponseBodySchema
>;

export type CreateMagicPublishingApiArg = CreateMagicPublishingRequestBody;
export type CreateMagicPublishingApiRes = CreateMagicPublishingResponseBody;

export const MagicPublishingStateSchema = z.enum(['started', 'failed', 'finished']);
export type MagicPublishingState = z.infer<typeof MagicPublishingStateSchema>;

export const GetMagicPublishingRequestApiArgSchema = z.object({
  requestId: z.string(),
});
export type GetMagicPublishingRequestApiArg = z.infer<typeof GetMagicPublishingRequestApiArgSchema>;

export const GetMagicPublishingRequestApiResSchema = z.object({
  id: z.string(),
  vehicleId: z.string(),
  state: MagicPublishingStateSchema,
  createdAt: z.string().datetime(),
  createdBy: z.string(),
  updatedAt: z.string().datetime().nullable(),
  updatedBy: z.string().nullable(),
});
export type GetMagicPublishingRequestApiRes = z.infer<typeof GetMagicPublishingRequestApiResSchema>;
